module.exports = __webpack_public_path__ + "static/footer-3-7e3218a8199169312d38eb2dc4e1aac2.jpg";